import React from "react";
import { Check } from "lucide-react";

export default function StakeholderPicker({ stakeholders, selected = [], onChange, testId = "stakeholder-picker" }) {
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  if (!stakeholders.length) {
    return <div className="text-xs text-slate-500 py-2" data-testid={`${testId}-empty`}>No stakeholders yet. Add them in the New Project setup.</div>;
  }
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {stakeholders.map((s) => {
        const on = selected.includes(s.id);
        return (
          <button type="button" key={s.id} onClick={() => toggle(s.id)} data-testid={`${testId}-chip-${s.id}`}
            title={[s.email, s.organization].filter(Boolean).join(" · ")}
            className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs border transition-colors ${on ? "bg-blue-500/20 border-blue-500/60 text-blue-200" : "border-slate-700 text-slate-400 hover:border-slate-500"}`}>
            {on && <Check size={11} />} {s.name}
          </button>
        );
      })}
    </div>
  );
}

export const stakeholderNames = (stakeholders, ids) =>
  stakeholders.filter((s) => ids.includes(s.id)).map((s) => s.name).join(", ");
